import * as SwitchPrimitives from "@radix-ui/react-switch";
import { use } from "react";

import {
  ColorContext,
  theme,
} from "@/components/canvas-editor/components/Container";
import { cn } from "@/lib/utils";

export const Switch = ({
  className,
  size = "md",
  ...props
}: React.ComponentProps<typeof SwitchPrimitives.Root> & {
  size?: "sm" | "md";
}) => {
  const color = use(ColorContext);

  return (
    <SwitchPrimitives.Root
      className={cn(
        "peer",
        "inline-flex",
        size === "md" ? "h-6 w-11" : "h-5 w-8",
        "shrink-0",
        "cursor-pointer",
        "items-center",
        "rounded-full",
        "border-2",
        "border-transparent",
        "transition-colors",
        "focus-visible:outline-hidden",
        "focus-visible:ring-2",
        "",
        "focus-visible:ring-offset-2",
        "focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed",
        "disabled:opacity-50",
        "data-[state=unchecked]:bg-slate-6 hover:data-[state=unchecked]:bg-slate-7 dark:data-[state=unchecked]:bg-slatedark-6 dark:hover:data-[state=unchecked]:bg-slatedark-7",
        theme.switch[color || "default"],
        className,
      )}
      {...props}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none",
          "block",
          size === "md" ? "h-5 w-5" : "h-4 w-4",
          "rounded-full",
          "bg-slate-app",
          "shadow-lg",
          "ring-0",
          "transition-transform",
          size === "md"
            ? "data-[state=checked]:translate-x-5"
            : "data-[state=checked]:translate-x-3",
          "data-[state=unchecked]:translate-x-0",
        )}
      />
    </SwitchPrimitives.Root>
  );
};
Switch.displayName = SwitchPrimitives.Root.displayName;
